import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SuppliersService } from '../../../shared/API-Service/services/suppliers.service';
import { environment } from 'src/environments/environment.prod';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-supplier-details',
  templateUrl: './supplier-details.component.html',
  styleUrls: ['./supplier-details.component.css']
})
export class SupplierDetailsComponent implements OnInit {
  customerinfo:any;
  id: string;
  SupplierDetails: any;
  commercialRegisteration: any;
  commercialRegisterationEx:any
  electronicCard: string;
  electronicCardEx: any;
  taxCard: string;
   taxCardEx: any;
  vatRegisterationCertificate: string;
  vatRegisterationCertificateEx: any;
  constructor(private SuppliersService:SuppliersService,private _Router:Router,private route : ActivatedRoute) { }

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get("id")) {
      console.log(this.route.snapshot.paramMap.get("id"))
      
       this.id =this.route.snapshot.paramMap.get("id");
       this.SuppliersService.GetSuppliersById(this.id).subscribe(async (res:any)=>{
         this.SupplierDetails=  await res.data;
    console.log(this.SupplierDetails)
    this.commercialRegisteration=environment.ServerImages_URL+'/'+this.SupplierDetails.commercialRegisteration
    this.commercialRegisterationEx=this.commercialRegisteration.split('.').pop();

    this.electronicCard=environment.ServerImages_URL+'/'+this.SupplierDetails.electronicCard
     this.electronicCardEx=this.electronicCard.split('.').pop();
    
    this.taxCard=environment.ServerImages_URL+'/'+this.SupplierDetails.taxCard
     this.taxCardEx=this.taxCard.split('.').pop();
    
    this.vatRegisterationCertificate=environment.ServerImages_URL+'/'+this.SupplierDetails.vatRegisterationCertificate
    this.vatRegisterationCertificateEx=this.vatRegisterationCertificate.split('.').pop();
         
       })
      // this.PartnersService.GetPartnersByid(this.id).subscribe(async (res:any)=>{
      //   console.log(res.data);
      // this.Partners=  await res.data;
      // this.imageLogo=environment.ServerImages_URL+'/'+this.Partners.image
      //   this.initForm(this.Partners);
        
      // })
     
    }
  }
OpenImage(imagesView){
    Swal.fire({
      imageUrl: imagesView,
      imageHeight: 400,
      imageAlt: 'A tall image',
      confirmButtonText:"الغاء"
    })
  }
  OpenPdf(imagesView){
    window.open(imagesView, "_blank");
 }
}

